import React from "react";
import { Form, redirect } from "react-router-dom";
import { getPost } from "./api";

const Forms = () => {
  return (
    <Form method="post" action="/blog">
      <input className="border" type="text" name="title" id="title" />
      <input className="border" type="text" id="text" name="post-text" />
      <button>Submit</button>
    </Form>
  );
};

export default Forms;

export async function action({ request }) {
  const formData = await request.formData();
  const post = {
    title: formData.get("title"),
    body: formData.get("post-text"),
  };
  try {
    await getPost(post);
  } catch (error) {
    console.log(error, "here it is");
  }

  return redirect("/");
}
